(() => {
  'use strict';
  const select = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  function init(root = document) {
    select('[data-mt]', root).forEach(section => {
      if (section.dataset.editorialReady) return;
      section.dataset.editorialReady = 'true';
      const tabs = select('[data-mt-tab]', section);
      const panels = select('[data-mt-panel]', section);
      const images = select('[data-mt-slide]', section);
      let active = 0;
      function show(index, focus = false) {
        if (!tabs.length) return;
        active = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          tab.classList.toggle('on', i === active);
          tab.setAttribute('aria-selected', String(i === active));
          tab.tabIndex = i === active ? 0 : -1;
          if (panels[i]) { panels[i].classList.toggle('on', i === active); panels[i].hidden = i !== active; }
          if (images[i]) images[i].classList.toggle('on', i === active);
        });
        if (focus) tabs[active].focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => show(index));
        tab.addEventListener('keydown', event => {
          const target = {ArrowRight: active + 1, ArrowLeft: active - 1, Home: 0, End: tabs.length - 1}[event.key];
          if (target !== undefined) { event.preventDefault(); show(target, true); }
        });
      });
      section.querySelector('[data-mt-prev]')?.addEventListener('click', () => show(active - 1));
      section.querySelector('[data-mt-next]')?.addEventListener('click', () => show(active + 1));
      section.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.dataset.materialBlock === event.detail.blockId);
        if (index >= 0) show(index);
      });
      show(0);
    });
    select('[data-ds-stage]', root).forEach(stage => {
      if (stage.dataset.editorialReady) return;
      stage.dataset.editorialReady = 'true';
      const slides = select('[data-ds-slide]', stage);
      const names = select('[data-ds-name]', stage);
      let active = 0;
      function show(index) {
        active = index;
        slides.forEach((slide, i) => slide.classList.toggle('on', i === active));
        names.forEach(name => name.classList.toggle('on', Number(name.dataset.dsName) === active));
        const caption = stage.querySelector('[data-ds-cap]');
        if (caption && slides[active]) caption.textContent = slides[active].getAttribute('aria-label') || '';
      }
      names.forEach(name => {
        if (name.closest('[aria-hidden="true"]')) return;
        name.setAttribute('role', 'button'); name.tabIndex = 0;
        name.addEventListener('click', () => show(Number(name.dataset.dsName)));
        name.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(Number(name.dataset.dsName)); }
        });
      });
      show(0);
    });
    select('[data-cxl-more]', root).forEach(button => {
      if (button.dataset.editorialReady) return;
      const section = button.closest('.shopify-section');
      const panel = section?.querySelector('[id^="cxl-more"]');
      if (!panel) return;
      button.dataset.editorialReady = 'true';
      button.setAttribute('aria-controls', panel.id);button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        panel.style.display = open ? 'grid' : 'none';
      });
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-editorial-zoom]');
    if (!button) return;
    const image = getComputedStyle(button).backgroundImage.match(/^url\(["']?(.*?)["']?\)$/)?.[1];
    if (!image) return;
    const dialog = document.createElement('dialog');dialog.className = 'editorial-zoom';
    const close = document.createElement('button');close.type = 'button';close.textContent = '×';
    close.setAttribute('aria-label', window.themeStrings?.close || 'Fermer');
    const figure = document.createElement('figure');const img = document.createElement('img');
    const caption = document.createElement('figcaption');caption.textContent = button.getAttribute('aria-label') || button.textContent.trim();
    img.src = image;img.alt = caption.textContent;figure.append(img, caption);dialog.append(close, figure);
    document.body.append(dialog);dialog.showModal();
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {dialog.remove();button.focus();});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
